// extracted by mini-css-extract-plugin
module.exports = {"footerMenuList":"FooterMenuList_footerMenuList__2cttc","button":"FooterMenuList_button__26Wzr"};